exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".StaticNotification_notificationBlock__2dQ1C{display:-webkit-box;display:flex;padding:20px;margin-bottom:20px}@media only screen and (max-width:960px){.StaticNotification_notificationBlock__2dQ1C{padding:15px 20px}}.StaticNotification_notificationBlock__2dQ1C.StaticNotification_warning__2L87p{background-color:#fbecd9}.StaticNotification_notificationBlock__2dQ1C.StaticNotification_error__3p2eQ{background-color:#f8e5ec}.StaticNotification_notificationBlock__2dQ1C.StaticNotification_info__3PtFL{background-color:#d9f5de}.StaticNotification_iconWrap__2qp-q{margin-right:15px}@media only screen and (max-width:960px){.StaticNotification_iconWrap__2qp-q{margin-right:10px}}.StaticNotification_message__37eaN{font-size:14px;line-height:20px;font-weight:400;color:#626469}@media only screen and (max-width:960px){.StaticNotification_message__37eaN{font-size:12px;line-height:20px;font-weight:400;line-height:18px}}", ""]);

// exports
exports.locals = {
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009530",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333",
	"textGray": "#9b9b9b",
	"textWhite": "#fff",
	"grayLight": "#9fa0a4",
	"grayBorder": "#e7e6e6",
	"containerWidthMain": "960",
	"heightDesktopHeader": "136px",
	"notificationBlock": "StaticNotification_notificationBlock__2dQ1C",
	"warning": "StaticNotification_warning__2L87p",
	"error": "StaticNotification_error__3p2eQ",
	"info": "StaticNotification_info__3PtFL",
	"iconWrap": "StaticNotification_iconWrap__2qp-q",
	"message": "StaticNotification_message__37eaN"
};